import { render } from "./MovieIndexPage.vue?vue&type=template&id=fb6eaf3a"
import script from "./MovieIndexPage.vue?vue&type=script&lang=js"
export * from "./MovieIndexPage.vue?vue&type=script&lang=js"

import "./MovieIndexPage.vue?vue&type=style&index=0&id=fb6eaf3a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__